export default ($engine, type = 'paragraph', clas) => {
  if ($engine?.hooks[type]) {
    const target = $engine?.hooks[type].filter((hook) => hook instanceof clas);
    if (target.length) return target[0];
  }
  return null;
};
